{
  "_provenance": {
    "ns": "feedback",
    "source": "FeedbackDialog, ErrorBoundary and the mobile chrome: PushBanner, MobileRouteGuard, NativePushBootstrap (#2109 R3 lane L8)"
  },
  "dialog": {
    "attachHint": "Optional. The dialog will briefly close while we capture.",
    "attachmentLabel": "Attachment",
    "attachScreenshot": "Attach screenshot of this page",
    "capturing": "Capturing the page…",
    "contextNote": "We’ll include the current page, your role, and your browser automatically — so you don’t have to.",
    "description": "Bugs, ideas, questions, praise — whatever’s on your mind. We read every one, and a question becomes something you can follow.",
    "messageLabel": "Your message",
    "messagePlaceholder": "What’s on your mind…",
    "removeScreenshot": "Remove screenshot",
    "screenshotPreviewAlt": "Screenshot preview",
    "screenshotSize": "~{{size}} KB",
    "send": "Send feedback",
    "sending": "Sending…",
    "title": "Send feedback",
    "typeLabel": "Type",
    "types": {
      "bug": {
        "hint": "Something broken",
        "label": "Bug"
      },
      "idea": {
        "hint": "Feature or improvement",
        "label": "Idea"
      },
      "other": {
        "hint": "Anything else",
        "label": "Other"
      },
      "praise": {
        "hint": "What you love",
        "label": "Praise"
      },
      "question": {
        "hint": "Something you need answered or decided",
        "label": "Question"
      }
    }
  },
  "errorBoundary": {
    "backToCaseload": "Back to caseload",
    "body": "Something went wrong while rendering this page. You can try again, or head back and reopen it.",
    "title": "This page hit an error"
  },
  "mobileGuard": {
    "adminBody": "Admin tools are designed for a larger screen. Sign in at <site>{{site}}</site> from a desktop browser.",
    "backToDashboard": "Back to dashboard",
    "goToToday": "Go to today",
    "signOut": "Sign out",
    "title": "This view is built for the website",
    "trferBody": "This tool is designed for a larger screen — but your day-to-day lives right here in the app."
  },
  "push": {
    "dismiss": "Dismiss notification",
    "open": "Open: {{title}}",
    "openWithBody": "Open: {{title}} — {{body}}"
  },
  "roleResync": {
    "description": "You switched roles in another window, so this page moved with you.",
    "title": {
      "admin": "You’re now signed in as an admin",
      "applicant": "You’re now signed in as an applicant",
      "parent": "You’re now signed in as a parent",
      "trfer": "You’re now signed in as a TRFer",
      "unknown": "You’re now signed in as {{role}}"
    }
  },
  "toast": {
    "captureFailedDescription": "You can still send the report without one.",
    "captureFailedTitle": "Couldn’t capture screenshot",
    "sendFailedDescription": "Please try again in a moment.",
    "sendFailedTitle": "Couldn’t send",
    "sent": "Your feedback is in front of the team.",
    "sentTitle": "Thanks — we got it",
    "sentWithScreenshot": "Your feedback and screenshot are in front of the team.",
    "tooLargeDescription": "Try again from a smaller window, or send without a screenshot.",
    "tooLargeTitle": "Screenshot too large to attach"
  }
}
